export class tokenRequest {
  quantity: number;
  upgradeQuantity: number;
  stagingQuantity: number;
  raQuantity: number;
  raBulkQuantity: number;
  capacityTB: number;
  ip: string;
  hostname: string;
  signature: string;
  comment: string;
}

export class tokenResponse {
  "ipAddr": string;
  "hostname": string;
  "cloneCode": string;
  "syncCode": string;
  "activationCode": string;
  "tokenCode": string;
  "upgradeCode": string;
  "stagingCode": string;
  "raCode": string;
  "raBulkCode": string;
}

export class SurrenderLicense {
  "product": string;
  "code": string;
  "comment": string;
}

export class SurrenderItem {
  hostname: string;
  code: string;
}

export class OfflineSurrenderRequest {
  product: string;
  uuid: string;
  token: string;
}
